export const setColorMode = (colorMode, toggleColorMode)=>{
    toggleColorMode();
    const event = new window.CustomEvent('color-mode-change', {
        detail: {
            colorMode
        }
    });
    window.dispatchEvent(event);
};
